<template>
  

  <v-container fluid>
    <v-dialog v-model="showAlert" max-width="500">
      <v-card>
        <v-card-title class="headline">{{$t('simulaciones.advertencia')}}</v-card-title>
        <v-card-text v-html="error_msg">
         
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showAlert = false">{{$t('simulaciones.cerrar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  
      <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>

      
     
         <!-- EX-PAGINADO -->
        <!-- <v-data-table-server
        density="compact"
        
        v-model:page="currentPage"            
        v-model:items-per-page="itemsPerPage"
        :items-length="totalItems"

        :headers="cabecera_tabla_simulaciones"
        :items="buscarporNombre(texto_a_buscar)"
          
          class="elevation-1 gris_muy_suave"   
          @update:options="obtener_lista_simulaciones"
       
      > -->
      <v-data-table
        density="compact"
        
        :headers="cabecera_tabla_simulaciones"
        :items="buscarporNombre(texto_a_buscar)"
          
          class="elevation-1 gris_muy_suave"   
       
      >
      
<!--  <span> <div class="ml-2 mt-0 text-caption gris_suave">Simulaciones</div>{{$t('general.nueva_simulacion')}}</span> -->

        <template v-slot:top>
          
          <v-toolbar flat color="white" style="padding-bottom: 20px;"   >
            
            <v-toolbar-title class="mb-6"><div class="ml-5 mt-3 text-caption gris_suave">{{$t('general.sim')}}</div>{{$t('simulaciones.titulo')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
             
            <v-btn  class="boton_crear selected" dark @click="nueva_simulacion"><span class="material-symbols-outlined">add</span>{{$t('simulaciones.boton.nueva')}}</v-btn>
            <v-btn  class="gris_medio" @click="obtener_lista_simulaciones"><span class="material-symbols-outlined">autorenew</span>{{$t('simulaciones.boton_actualizar')}}</v-btn>
            <!-- <v-btn  class="gris_medio" ><span class="material-symbols-outlined">filter_list</span>{{$t('simulaciones.filtrar')}}</v-btn> -->
           <!--  <v-btn  class="gris_medio" ><span class="material-symbols-outlined">swap_vert</span>{{$t('simulaciones.ordenar')}}</v-btn> -->
            
            <!--
              <v-text-field
                v-model="texto_a_buscar"
                :placeholder="$t('simulaciones.busqueda')"
                density="comfortable"
                hide-details
                variant="solo-filled"
                prepend-inner-icon="mdi-magnify"
                class="campo-buscador pr-3"
               
            ></v-text-field>
            -->

            <v-text-field
              v-model="texto_a_buscar"
              :placeholder="$t('simulaciones.busqueda')"
              density="comfortable"
              hide-details
              variant="solo-filled"
              prepend-inner-icon="mdi-magnify"
              class="campo-buscador pr-3"
              @keydown.enter="obtener_lista_simulaciones"
            ></v-text-field>

  
          </v-toolbar>
         
        </template>
        
  <!--       <template v-slot:headers="props">
          <tr>
            
              <th
                v-for="header in props.headers[0]"
                :key="header.key"
                class="header-custom"
                style="text-align: left !important;"
              >
            {{ header.title }}
          </th>
            
          
            
          </tr>
        </template> -->

        <template v-slot:item="{ item }">
  
          <tr>
          <td style="width: 400px; min-width: 200px;">
            <v-textarea
              v-model="item.name"
              variant="outlined"
              density="compact"
              hide-details
              rows="1"
              auto-grow
              class="name-field-wrap"
              :readonly="vista_operador"
              @change="!vista_operador && cambiarNombre(item)"
            />
          </td>           
          <td>{{ item.username }}</td>            
          <td>{{ this.calcularHoraLocal(item.created_formateada) }}</td>
          <td>{{ item.START_DATE_SIMULATION }}</td>
          <td>{{ item.HORIZON }}</td>
          <!-- <td>{{ this.calcularHoraLocal(item.last_update) }}</td>  -->
          <!--<td>{{ this.decodifica_estado(item.status) }}</td>-->
          <td>
          
          <v-icon 
            v-if="item.status === 3" 
            class="spin-icon" 
            color="blue"
          >
            mdi-loading
          </v-icon>

          <v-icon v-else-if="item.status === 4" class="sentimiento_verde">mdi-check-circle</v-icon>
          </td>
          <td>
          <v-checkbox
              :disabled="vista_operador"
              v-model="item.VALID"
              :true-value="1"
              :false-value="0"              
              @change="actualizar_estado(item.id, item.VALID, usuario)"
              hide-details
              
              :true-icon="CustomCheckedIcon"
              :false-icon="'mdi-checkbox-blank-outline'"
              dense
            ></v-checkbox>
            
          </td>            
          <!-- check_box_outline_blank -->
          <!-- <span class="material-symbols-outlined">delete</span> -->
  
<td style="justify-content: left !important;">
  <div class="icon-container" >
    <!-- Ícono para "Ver Resultado" -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          v-if="item.status === 4" 
          
          @click="ver_resultado_simulacion(item)"
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
          style="margin-right: 12px;"
        >
        <span class="material-symbols-outlined">visibility</span>
         
        </v-icon>
      </template>
      {{$t('simulaciones.boton.ver_resultado')}}
    </v-tooltip>

    <!-- Ícono para "Borrar Simulación" -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          :disabled="vista_operador"
          v-if="item.status === 4" 
          
          @click="borrar_simulacion(item)" 
          v-bind="attrs" 
          v-on="on"
          class="sentimiento_rojo clickable-icon"
        >
          <span class="material-symbols-outlined">delete</span>
        </v-icon>
      </template>
      {{$t('simulaciones.boton.borrar_simulacion')}}
    </v-tooltip>
  </div>
</td>


          </tr> 
  
        </template>
        <!--     # EX-PAGINADO -->
        <!-- </v-data-table-server> -->
      </v-data-table>
       

  </v-container>








</template>


<script>
import store from '../store';
import axios from 'axios';
import { mapGetters } from 'vuex';
import '@vuepic/vue-datepicker/dist/main.css'
import ComponenteLoading from './ComponenteLoading.vue';
import Swal from "sweetalert2";
import { h } from 'vue';

export default {




    data() {
        return {
          texto_a_buscar:"",
          usuario: store.state.usuarioNombre,
          vista_operador: false,
          loading: false,
          mensaje_loading: "",
          showAlert:false,
          error_msg:"",
          contenido: 'hola mundo', // Definir las propiedades reactivas
          mode: 'light',

            lista_simulaciones: [],

            cabecera_tabla_simulaciones: [
              { title: this.$t('simulaciones.tabla.nombre'), key: 'name' ,headerProps:{class:'header-custom'}},            
              { title: this.$t('simulaciones.tabla.usuario'), key: 'username',headerProps:{class:'header-custom'} },              
              { title: this.$t('simulaciones.tabla.fecha'), key: 'created',headerProps:{class:'header-custom'} },
              { title: this.$t('simulaciones.tabla.START_DATE_SIMULATION'), key: 'START_DATE_SIMULATION',headerProps:{class:'header-custom'} },
              { title: this.$t('simulaciones.tabla.HORIZON'), key: 'HORIZON',headerProps:{class:'header-custom'} },
              { title: this.$t('simulaciones.tabla.estado'), key: 'status',headerProps:{class:'header-custom'} },              
              { title: this.$t('simulaciones.tabla.valida'), key: 'VALID',sort: (a, b) => {return a - b;}, sortable: true,headerProps:{class:'header-custom'} },              
              { title: this.$t('simulaciones.tabla.acciones'), key: 'actions', sortable: false, headerProps:{class:'header-custom', } },
            ],



          isSaving: false,
            
          usuario_id: store.state.usuarioID,

          dialog: false,
          dialog_proceso: false,
          editedIndex: -1,

          page: 1,
          itemsPerPage: 10,
          currentPage: 1,
          totalItems: 0,
         
        };
      },

  watch: {    
    
    '$i18n.locale'() {
      
      this.cabecera_tabla_simulaciones = [
        { title: this.$t('simulaciones.tabla.nombre'), key: 'name',headerProps:{class:'header-custom'}  },            
        { title: this.$t('simulaciones.tabla.usuario'), key: 'username',headerProps:{class:'header-custom'} },              
        { title: this.$t('simulaciones.tabla.fecha'), key: 'created',headerProps:{class:'header-custom'} },
         { title: this.$t('simulaciones.tabla.START_DATE_SIMULATION'), key: 'START_DATE_SIMULATION', headerProps:{class:'header-custom'} },
          { title: this.$t('simulaciones.tabla.HORIZON'), key: 'HORIZON', headerProps:{class:'header-custom'} },
        { title: this.$t('simulaciones.tabla.estado'), key: 'status',headerProps:{class:'header-custom'} }, 
         { title: this.$t('simulaciones.tabla.valida'), key: 'VALID',sort: (a, b) => {return a - b;}, sortable: true,headerProps:{class:'header-custom'} },  
          { title: this.$t('simulaciones.tabla.acciones'), key: 'actions', sortable: false, headerProps:{class:'header-custom'} },

      ];



    },



  },


  components: {
    ComponenteLoading,
  },
    mounted(){

        
        this.obtener_lista_simulaciones()

    },
    computed:{
      ...mapGetters(['getMiVariableGlobal']),
      CustomCheckedIcon() {
      return {
        functional: true,
        render() {
          return h('span', { class: 'material-symbols-outlined gris_medio' }, 'check_box');
        }
      };
    }
      
    },

  created(){
      // Cargar configuración proporcionada desde `main.js`
      fetch('/config.json')
        .then((response) => response.json())
        .then((config) => {
          this.mostrar_boton_descargar_in = config.mostrar_boton_descargar_in;  
          this.usuarios_operadores = config.usuarios_operadores;
          
          
          
          if (this.usuarios_operadores.includes(store.state.usuarioNombre)) {
              this.vista_operador = true;
          } else {
              this.vista_operador = false;
          }
          
                  
        })
        .catch((error) => {
          console.error('Error al cargar la configuración:', error);
          
        });
    },
    
    methods: {


    async cambiarNombre(item) {
      if (this.vista_operador) {
        console.log("Vista operador no puede cambiar nombres de simulaciones");
        return;
      }

      const result = await Swal.fire({
        title: this.$t('mensajes.estas_seguro'),
        text: this.$t('mensajes.cambiar_nombre_simulacion') + item.id,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t('comun.boton_ok'),
        cancelButtonText: this.$t('comun.boton_cancelar'),
      });

      if (result.isConfirmed) {
        this.loading = true;
        this.mensaje_loading = "";
        await this.$nextTick();

        axios({
          method: 'post',
          url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion/nombre/',
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          },
          data: {
            id: item.id,
            uuid: item.uuid || "",
            nuevo_nombre: item.name
          }
        })
        .then(() => {
          this.loading = false;
          this.mensaje_loading = "";
        });
      } else {
        this.obtener_lista_simulaciones();
      }
    },
      buscarporNombre(texto){
        
        console.log("Se llama a buscar: ", texto)

        //  EX-PAGINADO
        // return this.lista_simulaciones
        // EX-PAGINADO 
        // /*
        const textoBuscado = texto.toLowerCase();

        // Usar filter() para crear un nuevo array con solo los elementos que coinciden
        const resultadosFiltrados = this.lista_simulaciones.filter(row => {
          // Asegúrate de que las propiedades existen y convertirlas a minúsculas
          const username = row['username'] ? row['username'].toLowerCase() : '';
          const name = row['name'] ? row['name'].toLowerCase() : '';
          const lastUpdate = row['created_formateada'] ? row['created_formateada'].toLowerCase() : ''; // O considera formatear la fecha si no es un string
          const lastApplication = row['START_DATE_SIMULATION'] ? row['START_DATE_SIMULATION'].toLowerCase() : ''; // O considera formatear la fecha si no es un string
          const HORIZON = row['HORIZON'] ? String(row['HORIZON']) : ''; // O considera formatear la fecha si no es un string

          return username.includes(textoBuscado) ||
                name.includes(textoBuscado) ||
                lastUpdate.includes(textoBuscado) ||
                lastApplication.includes(textoBuscado) ||
                HORIZON.includes(textoBuscado);
              
              
        }
        )
        console.log("Filtrados: ", resultadosFiltrados)
        return resultadosFiltrados
        //this.$store.dispatch('actualizarListaSimulations', this.lista_simulaciones);
        //  EX-PAGINADO 
        // */
      },
      decodifica_estado(estado){
        if (estado == 1) return this.$t('simulaciones.estados.creada');
        if (estado == 2) return this.$t('simulaciones.estados.guardada');
        if (estado == 3) return this.$t('simulaciones.estados.en_ejecucion');
        if (estado == 4) return this.$t('simulaciones.estados.ejecutada_ok');
        if (estado == 5) return this.$t('simulaciones.estados.ejecutada_nok');
        if (estado == 6) return this.$t('simulaciones.estados.cancelada');
        if (estado == 7) return this.$t('simulaciones.estados.borrada');        
      },



      obtener_lista_simulaciones(){
        
           // EX-PAGINADO
          // const limit = this.itemsPerPage
          // const offset = (this.currentPage - 1) * this.itemsPerPage
          // let url = ""
          
          // if (this.texto_a_buscar == "") {
          //   url = '/api/simulacion?limit=' + limit + '&offset=' + offset
          // } else {
          //   url = '/api/simulacion?limit=' + limit + '&offset=' + offset + '&search=' + this.texto_a_buscar 
          // }
          
          this.loading = true;
          this.mensaje_loading = this.$t('simulaciones.descargando')
          axios(
              {
                  method: 'get',
                  // EX-PAGINADO
                  // url: process.env.VUE_APP_API_BASE_URL + url,    
                  //Cambio:
                  url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion?vista_operador=' + (this.vista_operador ? 'true' : 'false') + '&username=' + encodeURIComponent(store.state.usuarioNombre || ''),
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {                  
              this.cargando = false;
              // EX-PAGINADO
              // let myObject = response.data.data;                            
              // this.totalItems = Number(response.data.metadata.totalCount);
              // Cambio
              let myObject = response.data.data;
              this.lista_simulaciones = myObject.filter(item => item.status !== 7); //Que no muestre las borradas
              
              if (this.vista_operador == true){
                this.lista_simulaciones = this.lista_simulaciones.filter(item => item.username == store.state.usuarioNombre); //Que no muestre las borradas
              }
              
              this.loading = false;  
              //El resumen (días con >1 activa o sin ninguna) lo calcula el backend
              //en /api/simulacion (mismo criterio que el daemon).
              const resumen = response.data.resumen_validez || { fechas_multiples: [], fechas_sin_valida: [] };
              console.log("RESUMEN: ",resumen)
              const fechasConMasDeUno = (resumen.fechas_multiples || []).join(', ');
              const fechasConCero = (resumen.fechas_sin_valida || []).join(', ');
              this.error_msg=""
              if (fechasConMasDeUno !== "") {
                this.showAlert=true;
                this.error_msg=this.$t('simulaciones.error_multiples', { fechas: fechasConMasDeUno }) + "<br>"
              }
              if (fechasConCero !== "") {
                this.showAlert=true;
                this.error_msg= this.error_msg+this.$t('simulaciones.error_ninguna', { fechas: fechasConCero })
             
              }
              this.$store.dispatch('actualizarListaSimulations', this.lista_simulaciones);
           
          })



      },
      //Formatea una fecha (Date o string) a "%d-%m-%Y", el formato que espera /api/validez-dia
      aDMY(fecha){
        const d = new Date(fecha);
        if (isNaN(d)) return null;
        const dd = String(d.getDate()).padStart(2,'0');
        const mm = String(d.getMonth()+1).padStart(2,'0');
        return `${dd}-${mm}-${d.getFullYear()}`;
      },
      //Devuelve el día ("%d-%m-%Y") de una simulación de la lista
      //Usa START_DATE_SIMULATION
      diaSimulacion(idSeleccionado){
        const obj = this.lista_simulaciones.find(o => o.id === idSeleccionado)
          || this.lista_simulaciones.find(o => o.id === parseInt(idSeleccionado));
        if (!obj) return null;
        if (obj.START_DATE_SIMULATION) return obj.START_DATE_SIMULATION.slice(0,10);
        return this.aDMY(obj.created);
      },
      //Helper: pregunta al backend si hay una simulación válida en un día (/api/validez-dia)
      async consultarValidezDia(dia, excluir_id = null){
        try {
          let url = process.env.VUE_APP_API_BASE_URL + '/api/validez-dia?dia=' + encodeURIComponent(dia);
          if (excluir_id != null) url += '&excluir_id=' + encodeURIComponent(excluir_id);
          const response = await axios({
            method: 'get',
            url,
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
            },
          });
          return response.data || { existe: false, fecha: dia };
        } catch (e) {
          console.error("Error consultando validez del día:", e);
          return { existe: false, fecha: dia };
        }
      },
      //¿Hay ya una simulación válida hoy para mañana? (lo calcula el backend)
      async hayOtroSeleccionadoHoy(){
        const manana = new Date();
        manana.setDate(manana.getDate() + 1);
        const dia = this.aDMY(manana);
        return await this.consultarValidezDia(dia);
      },
      // Función que revisa cada 100ms si el dialogo se cerró
        esperarCierreDialogo() {
              return new Promise((resolve) => {
                const interval = setInterval(() => {
                  if (!this.showAlert) {
                    clearInterval(interval);
                    resolve();
                  }
                }, 100); 
              });
            },
      //Función que envía a la ruta de crear una nueva simulación, avisando previamente si existen ya simulaciones activas
      async nueva_simulacion(){
        const hayMasSeleccionado=await this.hayOtroSeleccionadoHoy();
        if(hayMasSeleccionado.existe){
          this.error_msg="Ya existe una simulación activa para el día "+hayMasSeleccionado.fecha+".<br>¡Por favor, deja solo una activa!"
          this.showAlert=true
          // Esperar que el usuario cierre el dialogo
        await this.esperarCierreDialogo();
        this.$router.push('/nueva-simulacion');
        }
        else{
          this.$router.push('/nueva-simulacion');
        }
          
        
        
      },
        //¿Hay OTRA simulación válida el mismo día que `idSeleccionado`? (lo calcula el backend)
       async hayOtroSeleccionado(idSeleccionado) {
        const dia = this.diaSimulacion(idSeleccionado);
        if (!dia) return { existe: false, fecha: null };
        return await this.consultarValidezDia(dia, idSeleccionado);
      },
      async actualizar_estado(id, valid, username){
          this.loading = true;
          this.mensaje_loading = this.$t('simulaciones.actualizando')
          let new_status = 0;
          const hayMasSeleccionado=await this.hayOtroSeleccionado(id)
          if (valid == true){
            new_status = 1;
            if (hayMasSeleccionado.existe){
              this.error_msg=this.$t('simulaciones.error_sim_duplicada', { fecha: hayMasSeleccionado.fecha });+"."
              this.showAlert=true;
              this.loading = false;
              const encontrado = this.lista_simulaciones.find(obj => obj.id === id);
              encontrado.VALID=0;
              return;
            }
          } else {
            new_status = 0;
            if (!hayMasSeleccionado.existe){
              this.error_msg=this.$t('simulaciones.error_sim_valida', { fecha: hayMasSeleccionado.fecha });+"."
              this.showAlert=true;
              await this.esperarCierreDialogo();
            }
          }           
          //console.log("Estado de simulaciones: ",id ," --- ",this.lista_simulaciones)               
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/cambiar-estado?simulation_id=' + id + '&new_status=' + new_status + '&username=' + username,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then(() => {                 
              this.loading = false;
              this.obtener_lista_simulaciones()     
          })
      },


      ver_resultado_simulacion(item){
        this.$router.push({
          name:'ComponenteResultadoSimulacion',
          params:{ id: item.id },
          query: {
            valid: item.VALID,
            created: this.calcularHoraLocal(item.created_formateada),
            name: item.name
          }
        }); 
      },


    async borrar_simulacion(item) {
      if (this.vista_operador){
        console.log("Vista operador no puede borrar simulaciones")
        alert("Operador no puede borrar simulaciones")
        return
      }
      try {
        

        this.errorMessage = null;
                
        try {
          const result = await Swal.fire({
            title: this.$t('mensajes.estas_seguro'),
            text: this.$t('mensajes.borrar_simulacion') + item.id,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t('comun.boton_ok'),
            cancelButtonText: this.$t('comun.boton_cancelar'),
          });

          if (result.isConfirmed) {
            this.loading = true;
            
            // Enviar los datos al servidor            
            const response = await axios({
                method: "delete",
                url: process.env.VUE_APP_API_BASE_URL + "/api/borrar-simulacion/" + item.id,
                withCredentials: true,
                headers: {
                  Authorization: "Bearer " + store.state.token,
                  "Access-Control-Allow-Origin": "*",
                  'Content-Type': 'application/json'
                },
              });

              console.log("Respuesta borrar simulación:", response.data);

              if (response.data?.status !== "success") {
                throw new Error(response.data?.message || response.data?.text || "Error borrando simulación");
              }
                      
            this.loading = false;

            // Mostrar mensaje de éxito
            Swal.fire(this.$t('mensajes.borrar_simulacion_ok_titulo'), this.$t('mensajes.borrar_simulacion_ok_subtitulo'), "success");
            this.$router.push('/'); //Nos vamos a la pagina de home
          }
        } catch (error) {
          console.error("Error al borrar la simulación:", error);
          this.loading = false;

          // Mostrar mensaje de error
          Swal.fire("Error", this.$t('mensajes.borrar_simulacion_nok'), "error");
        }
        
      } catch (error) {
        // Maneja errores de validación
        this.errorMessage = error.inner.map((e) => e.message).join(", ");
        console.error("Errores de validación:", this.errorMessage);
        Swal.fire("Errores de validacion", this.errorMessage, "error");
      }








    },




    calcularHoraLocal(fechaString) {
        // Convertir la fecha del string al formato Date
        const [dia_entero, hora_min] = fechaString.split(' ');
        const [day, month, year] = dia_entero.split('-');
        const [hora, min] = hora_min.split(':');
        // Crear un objeto Date en UTC
        const fechaUTC = new Date(Date.UTC(year, month - 1, day, hora, min));

        // Convertir a la hora local del dispositivo
        const fechaLocal = new Date(fechaUTC);

        // Formatear la salida con hora local
        const d = String(fechaLocal.getDate()).padStart(2, "0");
        const m = String(fechaLocal.getMonth() + 1).padStart(2, "0");
        const y = fechaLocal.getFullYear();
        const h = String(fechaLocal.getHours()).padStart(2, "0");
        const minLocal = String(fechaLocal.getMinutes()).padStart(2, "0");
        // Formatear la fecha local al mismo formato que el original
        /* const year = fechaLocal.getFullYear();
        const month = String(fechaLocal.getMonth() + 1).padStart(2, "0");
        const day = String(fechaLocal.getDate()).padStart(2, "0");
        const hours = String(fechaLocal.getHours()).padStart(2, "0");
        const minutes = String(fechaLocal.getMinutes()).padStart(2, "0"); */

        return `${d}-${m}-${y} ${h}:${minLocal}`;
    },

    



    },







}
</script>


<style scoped>
.name-field-wrap textarea {
  line-height: normal;
}
.icon-container {
  display: flex;
  justify-content: left;
  align-items: center;
}


/* Animación simple para el ícono */
.spin-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

::v-deep(.v-data-table-footer) {
  color: #686868; 
  font-weight: bold; 
}




</style>